import * as mutationTypes from './mutation-types';
import * as actionTypes from './action-types';
import SessionManager from '@/common/storage/SessionManager';

const COOKIE_KEY_LOGIN = 'registerLogin';
const COOKIE_KEY_VERIFY_MAIL = 'hasShowVerify';
const COOKIE_KEY_OPEN_ID = 'openid';
const COOKIE_KEY_SVC_OPEN_ID = 'svc_openid';
const state = {
  ready: false,
  user: {
    isLogin: false,
    qq: '',
    isVerifyMail: false,
    news: '',
    userName: '',
    openid: null,
    isVerifyPhone: false,
    token: ''
  },
  sign: null,
  layoutMode: null
};

const actions = {
  [actionTypes.SAVE_USER_INFO]({ commit }, userInfo) {
    commit(mutationTypes.SAVE_USER_INFO, userInfo);
  },
  [actionTypes.SAVE_SIGN]({ commit }, sign) {
    commit(mutationTypes.SAVE_SIGN, sign);
  },
  [actionTypes.VALIDATE_USER_PHONE]({ commit }) {
    commit(mutationTypes.VALIDATE_USER_PHONE);
  },
  [actionTypes.VALIDATE_USER_MAIL]({ commit }) {
    commit(mutationTypes.VALIDATE_USER_MAIL);
  },
  [actionTypes.CLEAR_USER_INFO]({ commit }) {
    commit(mutationTypes.SAVE_USER_INFO, {
      isLogin: false,
      qq: '',
      isVerifyMail: false,
      isVerifyPhone: false,
      news: '',
      openid: null,
      userName: '',
      token: ''
    });
    // 向后兼容
    SessionManager.setItem(COOKIE_KEY_OPEN_ID, '');
    SessionManager.setItem(COOKIE_KEY_SVC_OPEN_ID, '');
  }
};

const mutations = {
  [mutationTypes.SAVE_USER_INFO](state, { isLogin, isVerifyMail, qq, news, openid, isVerifyPhone, userName, token }) {
    let user = state.user;
    state.ready = true;
    user.isLogin = isLogin;
    user.isVerifyMail = isVerifyMail;
    user.isVerifyPhone = isVerifyPhone;
    user.qq = qq;
    user.userName = userName;
    user.news = news;
    user.openid = openid;
    user.token = token;

    // 向后兼容
    SessionManager.setItem(COOKIE_KEY_OPEN_ID, openid);
    SessionManager.setItem(COOKIE_KEY_SVC_OPEN_ID, openid);
    SessionManager.setItem(COOKIE_KEY_LOGIN, isLogin ? '1' : '0');
    SessionManager.setItem(COOKIE_KEY_VERIFY_MAIL, isVerifyMail ? '1' : '0');
  },

  [mutationTypes.SAVE_SIGN](state, data) {
    state.ready = true;
    state.sign = data;
  },
  [mutationTypes.VALIDATE_USER_PHONE](state) {
    let user = state.user;
    user.isVerifyPhone = true;
  },
  [mutationTypes.VALIDATE_USER_MAIL](state) {
    let user = state.user;
    user.isVerifyMail = true;
  }
};

export default {
  state,
  actions,
  mutations
};



// WEBPACK FOOTER //
// ./src/store/open/index.js